import React, { useCallback, useEffect, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
  Button,
  FormControlLabel,
  Switch,
} from '@mui/material';
import { NO_SUMMARY } from './SummaryConstants';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DownloadIcon from '@mui/icons-material/Download';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { MAIN_BLUE } from '../../color';
import CustomToolbar from './CustomComponent/CustomToolbar';
import SideDrawer from './SideDrawer/SideDrawer';
import {
  getConsolidatedTimings,
  getSummary,
} from '../../services/TimingService';
import { getHolidays } from '../../admin/Services/MasterdataService';
import { getUserData, getUserLeaves } from '../../services/UserService';
import { downloadUserTasks } from '../../services/UserService';
import { useDispatch, useSelector } from 'react-redux';
import KeycloakService from '../../services/KeycloakService';
import ViewSummary from './ViewSummary';
import MyLoader from './TimingLoader/Timing_Loader';
import TableLoader from './TimingLoader/ViewSummary_Loader';
import CustomEvent from './CustomComponent/CustomEvent';
import { msToTime } from '../../utils/TimeConversionFunctions';
import './Scroller.css';
import { animateScroll } from 'react-scroll';
import GenericLoader from '../../components/Loader/GenericLoader';
import { TimesheetsComponentLoaderAttribute } from '../../constants';
import CalendarView from '../Leaves/CalendarView/CalendarView';
import { getUserWFH } from '../../services/WFHService';
import { getLeaveTypeForUser } from '../../services/UserService';
import { wfhCalenderHighlightColor } from '../../constants';
import { Stack, Chip } from '@mui/material';
const localizer = momentLocalizer(moment);
const TimeCalendar = Calendar;
const dt = new Date(
  new Date().getFullYear(),
  new Date().getMonth(),
  1,
).toLocaleDateString('en-CA');
const date = new Date();

const TimesheetsComponent = (props) => {
  const people = useSelector((state) => state.peopleState);
  const currentUserId = KeycloakService.getUserDetail();
  const filterState = useSelector((state) => state.filterState);
  const [showError, setShowError] = useState(false);
  const [noSummary, setNoSummary] = useState(false);

  const [loader, setLoader] = React.useState(true);
  const [summaryloader, setSummaryLoader] = React.useState(true);
  const [slotSelectDate, setSlotSelectDate] = React.useState(new Date());
  const [drawerState, setDrawerState] = React.useState({ right: false });
  const [monthlyTimings, setMonthlyTimings] = useState([]);
  const [consolidatedPieData, setConsolidatedPieData] = useState([]);
  const [totalHours, setTotalHours] = useState();
  const [officeHours, setOfficeHours] = useState();
  const [externalHours, setExternalHours] = useState();
  const [remoteOfficeHours, setRemoteOfficeHours] = useState();
  const [clientOfficeHours, setClientOfficeHours] = useState();
  const [workTravelHours, setWorkTravelHours] = useState();
  const [weekendWorkingHours, setWeekendWorkingHours] = useState();
  const [wfhHours, setWfhHours] = useState();
  const [expectedHours, setExpectedHours] = useState();
  const [labels, setLabels] = useState([]);
  const [labelsFlag, setLabelsFlag] = useState(false);
  const [parsedEventsData, setParsedEventsData] = useState([]);

  const [checked, setChecked] = useState(people.checked);
  const handleChange = () => {
    setChecked(!checked);
  };

  const [startDate, setStartDate] = useState(
    new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1,
    ).toLocaleDateString('en-CA'),
  );
  const [endDate, setEndDate] = useState(
    startDate === dt
      ? new Date().toLocaleDateString('en-CA')
      : new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0,
        ).toLocaleDateString('en-CA'),
  );

  const [height, setHeight] = useState('85vh');
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const scrollToBottom = () => {
    animateScroll.scrollToBottom({
      containerId: 'options-holder',
    });
  };

  const [expanded, setExpanded] = React.useState(false);
  const flipSummaryContainer = () => () => {
    setExpanded(!expanded);
    scrollToBottom();
  };
  const [userAvailedLeaves, setUserAvailedLeaves] = useState([]);
  const [userAvailedWFH, setUserAvailedWFH] = useState([]);
  const [holidayDate, setHolidayDate] = useState([]);
  const dispatch = useDispatch();

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: 'SHOW_NOTIFICATION',
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };
  const getLeavesList = async () => {
    let userLeaves;
    let employeeId;

    if (people.id === '' && currentUserId !== undefined) {
      employeeId = currentUserId;
    } else {
      employeeId = people.id;
    }

    userLeaves = await getUserLeaves(employeeId, {
      status: 'APPROVED',
    });
    if (userLeaves.status !== 200) {
      dipatchNotification(userLeaves.type, userLeaves.message);
    }
    if (userLeaves.isError === false) {
      setUserAvailedLeaves(userLeaves.data.data.content);
      return userLeaves.data.data.content;
    }
  };

  const getLeaveTypesLabels = async () => {
    const response = await getLeaveTypeForUser(date.getFullYear());
    let leavesLabel = [];
    if (response.isError === false) {
      setLabelsFlag(true);
      response.data.map((data) => {
        leavesLabel.push({
          id: data.id,
          label: data.leaveName,
          color: data.color,
        });
      });
      setLabels([
        {
          id: 1000,
          label: 'WFH',
          color: wfhCalenderHighlightColor,
        },
        ...leavesLabel,
      ]);
    } else {
      setLabels([
        {
          id: 1000,
          label: 'WFH',
          color: wfhCalenderHighlightColor,
        },
      ]);
    }
    if (response.status !== 200) {
      setLabelsFlag(false);
      dipatchNotification(response.type, response.message);
    }
  };

  const getWfhList = async () => {
    let userWFH;
    let employeeId;
    let filteredData;

    if (people.id === '' && currentUserId !== undefined) {
      employeeId = currentUserId;
    } else {
      employeeId = people.id;
    }
    userWFH = await getUserWFH(employeeId, 'WFH', 0, 0, {});
    if (userWFH.status !== 200) {
      dipatchNotification(userWFH.type, userWFH.message);
    } else {
      filteredData = userWFH.data.data.content.filter(
        (item) =>
          item.status === 'APPROVED' ||
          item.status === 'TASK_PENDING' ||
          item.status === 'TASK_APPROVED',
      );
    }

    if (userWFH.isError === false) {
      setUserAvailedWFH(filteredData);
      setLoader(false);
      return filteredData;
    }
  };

  const getHoliday = async () => {
    const user = await getUserData(
      people.id === '' ? currentUserId : people.id,
    );
    if (user.data.locationId) {
      const response = await getHolidays(
        user.data.locationId,
        startDate,
        new Date(
          startDate.slice(0, 4),
          startDate.slice(5, 7),
          0,
        ).toLocaleDateString('en-CA'),
      );
      const holidayList = response;
      if (holidayList.isError === false) {
        setHolidayDate(holidayList.data);
        return holidayList.data;
      }
    }
  };

  useEffect(() => {
    consolidatedTimings();
    displaySummary();
    getLeaveTypeForUser(date.getFullYear());
    getLeaveTypesLabels();
  }, [startDate, endDate]);

  const displaySummary = async () => {
    const summaryData = await getSummary(
      startDate,
      endDate,
      people.id === '' ? currentUserId : people.id,
    );
    if (summaryData.isError === false) {
      setExternalHours(msToTime(summaryData.data.totalExternalHours));
      setRemoteOfficeHours(
        msToTime(summaryData.data.totalRemoteOfficeHours || 0),
      );
      setClientOfficeHours(
        msToTime(summaryData.data.totalClientOfficeHours || 0),
      );
      setWorkTravelHours(
        msToTime(summaryData.data.totalWorkTravelHours || 0),
      );
      setWeekendWorkingHours(
        msToTime(summaryData.data.totalWeekendWorkingHours || 0),
      );
      setOfficeHours(msToTime(summaryData.data.totalOfficeHours));
      setWfhHours(msToTime(summaryData.data.totalWfhHours));
      setTotalHours(msToTime(summaryData.data.totalHours));
      setExpectedHours(msToTime(summaryData.data.expectedHours));
      setSummaryLoader(false);
      setLoader(false);
    }
    setLoader(false);
    if (summaryData.status === '404') {
      setNoSummary(true);
      setSummaryLoader(false);
    }
    if (summaryData.status !== '200') {
      dipatchNotification(summaryData.type, summaryData.message);
    }
  };

  const consolidatedTimings = async () => {
    const consolidatedResponse = await getConsolidatedTimings(
      people.id === '' ? currentUserId : people.id,
      startDate,
      endDate,
    );
    if (consolidatedResponse.isError === false) {
      const holidayList = await getHoliday();
      const userLeavesList = await getLeavesList();
      const userWfhList = await getWfhList();
      setMonthlyTimings(consolidatedResponse.data.content);
      setDailyEvents(
        consolidatedResponse.data.content,
        holidayList,
        userLeavesList,
        userWfhList,
      );
    }
    if (consolidatedResponse.status !== 200) {
      dipatchNotification(
        consolidatedResponse.type,
        consolidatedResponse.message,
      );
    }
  };

  const setDailyEvents = (
    monthlyTimings,
    holidays,
    userLeavesList,
    userWfhList,
  ) => {
    const dailyEvents = [];

    if (holidays && holidays.length > 0) {
      const holidayEvents = holidays.map((holiday) => {
        let currentDate = new Date(holiday.date);
        if (currentDate.getMonth() !== activeMonth) {
          return;
        }
        const matchedHolidayEvent = monthlyTimings.find((time) => {
          return time.date === holiday.date;
        });
        if (matchedHolidayEvent) {
          return {
            ...matchedHolidayEvent,
            start: holiday.date,
            end: holiday.date,
            holiday: holiday.occasion,
          };
        }
        return {
          start: holiday.date,
          end: holiday.date,
          holiday: holiday.occasion,
          date: holiday.date,
        };
      });
      dailyEvents.push(...holidayEvents);
    }

    if (userWfhList && userWfhList.length > 0) {
      const wfhEvents = userWfhList
        .map((wfh) => {
          let currentDate = new Date(wfh.startDate);

          const endDate = new Date(wfh.endDate);
          if (
            currentDate.getMonth() !== activeMonth &&
            endDate.getMonth() !== activeMonth
          ) {
            return [];
          }
          const miniEvents = [];

          while (currentDate <= endDate) {
            if (currentDate.getMonth() !== activeMonth) {
              currentDate.setDate(currentDate.getDate() + 1);
              continue;
            }
            const currentDateStr = currentDate.toISOString().split('T')[0];

            const isWeekend =
              moment(currentDate).day() === 0 ||
              moment(currentDate).day() === 6;

            const isHoliday =
              holidays?.findIndex(
                (holiday) => holiday.date === currentDateStr,
              ) !== -1;

            if (
              currentDate.getMonth() !== activeMonth ||
              isWeekend
              //  ||
              // isHoliday
            ) {
              currentDate.setDate(currentDate.getDate() + 1);
              continue;
            }
            const wfhdayevent = monthlyTimings.find((time) => {
              return time.date === currentDateStr;
            });

            const holidayWfhEvent = dailyEvents.find((event) => {
              return event.start === currentDateStr;
            });
            if (holidayWfhEvent) {
              const indexForRemoval = dailyEvents?.findIndex(
                (event) => event === holidayWfhEvent,
              );
              if (holidayWfhEvent !== -1) {
                dailyEvents.splice(indexForRemoval, 1);
                miniEvents.push({
                  ...holidayWfhEvent,
                  wfh: 'WFH',
                });
              }
            } else if (wfhdayevent) {
              miniEvents.push({
                ...wfhdayevent,
                start: currentDateStr,
                end: currentDateStr,
                wfh: 'WFH',
              });
            } else {
              miniEvents.push({
                start: currentDateStr,
                end: currentDateStr,
                wfh: 'WFH',
                startDate: wfh.startDate,
                endDate: wfh.endDate,
              });
            }
            currentDate.setDate(currentDate.getDate() + 1);
          }

          return miniEvents;
        })
        .flat();
      dailyEvents.push(...wfhEvents);
    }

    if (userLeavesList && userLeavesList.length > 0) {
      const leaveEvents = userLeavesList
        .map((leave) => {
          let currentDate = new Date(leave.startDate);
          const endDate = new Date(leave.endDate);
          if (
            currentDate.getMonth() !== activeMonth &&
            endDate.getMonth() !== activeMonth
          ) {
            return [];
          }
          const miniEvents = [];
          while (currentDate <= endDate) {
            const isWeekend =
              moment(currentDate).day() === 0 ||
              moment(currentDate).day() === 6;
            const isHoliday =
              Array.isArray(holidays) &&
              holidays.findIndex(
                (holiday) =>
                  holiday.date === moment(currentDate).format('YYYY-MM-DD'),
              ) !== -1;
            const currentDateStr = currentDate.toISOString().split('T')[0];
            if (
              currentDate.getMonth() !== activeMonth ||
              isWeekend ||
              isHoliday
            ) {
              currentDate.setDate(currentDate.getDate() + 1);
              continue;
            }
            const leavedayevent = monthlyTimings.find((time) => {
              return currentDateStr === time.date;
            });
            if (isHoliday) {
            } else if (!isWeekend && !isHoliday) {
              if (leavedayevent) {
                miniEvents.push({
                  ...leavedayevent,
                  start: currentDateStr,
                  end: currentDateStr,
                  leave: leave.leaveId,
                  leaveId: leave.leaveId,
                });
              } else {
                miniEvents.push({
                  start: currentDateStr,
                  end: currentDateStr,
                  leave: leave.leaveId,
                  leaveId: leave.leaveId,
                  startDate: leave.startDate,
                  endDate: leave.endDate,
                });
              }
            }
            currentDate.setDate(currentDate.getDate() + 1);
          }
          return miniEvents;
        })
        .flat();
      dailyEvents.push(...leaveEvents);
    }

    const workingDayEvents = [];
    if (monthlyTimings && monthlyTimings.length !== 0) {
      monthlyTimings.map((time) => {
        const matchedEvent = dailyEvents.find((item) => {
          return item.date === time.date;
        });
        if (matchedEvent) {
        } else {
          workingDayEvents.push({
            ...time,
            start: time.date,
            end: time.date,
          });
        }
      });
    }
    dailyEvents.push(...workingDayEvents);
    setParsedEventsData(dailyEvents);
  };
  const selectSpecificDate = (data) => {
    const selectedDateConsolidated = monthlyTimings.find(
      (silngleDayTiming) =>
        moment(silngleDayTiming.date).format('DD/MM/YYYY') ===
        moment(data.start).format('DD/MM/YYYY'),
    );

    if (selectedDateConsolidated) {
      if (
        !selectedDateConsolidated.flag &&
        !selectedDateConsolidated.totalHrs
      ) {
        return;
      }
      setSlotSelectDate(data.start);
      setConsolidatedPieData((data) => [
        {
          values: [
            selectedDateConsolidated.officeHrs,
            selectedDateConsolidated.breaks,
            selectedDateConsolidated.wfhHrs,
            selectedDateConsolidated.remoteOfficeHrs || 0,
            selectedDateConsolidated.externalHrs,
            selectedDateConsolidated.clientOfficeHrs || 0,
            selectedDateConsolidated.workTravelHrs || 0,
            selectedDateConsolidated.weekendWorkingHrs || 0,
          ],

          labels: [
            'Work Hours',
            'Break Hours',
            'WFH Hours',
            'Remote Office Hours',
            'External Hours',
            'Client Office Hours',
            'Work Travel Hours',
            'Weekend Working Hours',
          ],
          type: 'pie',
          marker: {
            colors: [
              '#26C6DA',
              '#FFEE58',
              '#AB47BC',
              '#66BB6A',
              '#FF7043',
              '#42A5F5',
              '#9CCC65',
              '#8D6E63',
            ],
          },
          hoverinfo: 'label',
          texttemplate: [
            msToTime(selectedDateConsolidated.officeHrs),
            msToTime(selectedDateConsolidated.breaks),
            msToTime(selectedDateConsolidated.wfhHrs),
            msToTime(selectedDateConsolidated.remoteOfficeHrs || 0),
            msToTime(selectedDateConsolidated.externalHrs),
            msToTime(selectedDateConsolidated.clientOfficeHrs || 0),
            msToTime(selectedDateConsolidated.workTravelHrs || 0),
            msToTime(selectedDateConsolidated.weekendWorkingHrs || 0),
          ],
        },
      ]);
      setDrawerState({ right: true });
    }
  };

  const toggleDrawer = useCallback((anchor, open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setDrawerState({ ...drawerState, [anchor]: open });
  });

  const dayPropGetter = (date) => {
    const isWeekend = moment(date).day() === 0 || moment(date).day() === 6;
    const isHoliday =
      holidayDate?.findIndex(
        (holiday) => holiday.date === moment(date).format('YYYY-MM-DD'),
      ) !== -1;
    const matchedLeave = userAvailedLeaves.find((item) =>
      moment(date).isBetween(item.startDate, item.endDate, null, '[]'),
    );
    const isInLeave = matchedLeave && !isWeekend;
    const leaveType = isInLeave ? matchedLeave.leaveId : null;
    const labelName = String(
      labels.find((item) => {
        return item.id === leaveType;
      })?.label,
    );
    const isUTO =
      labelName.toLowerCase().includes('unpaid') ||
      labelName.toLowerCase().includes('loss');
    const leaveBackgroundColor = isUTO ? '#FF6F7D' : '#ffcdd2';
    const wfhBackgroundColor = labels.find(
      (item) => item.label === 'WFH',
    )?.color;
    const isInWFH =
      userAvailedWFH?.findIndex((item) =>
        moment(date).isBetween(item.startDate, item.endDate, null, '[]'),
      ) !== -1 && !isWeekend;
    if (isHoliday) {
      return {
        style: {
          backgroundColor: '#C8E6C9',
          color: 'white',
        },
      };
    } else if (isInWFH) {
      return {
        style: {
          backgroundColor: wfhBackgroundColor,
          color: 'white',
        },
      };
    } else if (isInLeave) {
      return {
        style: {
          backgroundColor: leaveBackgroundColor,
          color: 'white',
        },
      };
    } else {
      return {};
    }
  };

  const handledownloadloadExcel = async () => {
    try {
      const byteArray = await downloadUserTasks(
        people.id === '' ? currentUserId : people.id,
        startDate,
        endDate,
        // filterState,
        '',
      );
      if (byteArray.isError === false || byteArray || byteArray.data) {
        const filename = 'Tasks.xlsx';
        // const paddedData = byteArray.data + '='.repeat(4 - (byteArray.data.length % 4));
        // const byteArrayData = Uint8Array.from(atob(paddedData), c => c.charCodeAt(0));
        const href = window.URL.createObjectURL(
          new Blob([byteArray.data], { type: 'application/octet-stream' }),
        );
        const link = document.createElement('a');
        link.href = href;
        link.download = filename;
        link.click();

        // document.body.removeChild(link);
        window.URL.revokeObjectURL(href);
      } else {
        console.error('Error downloading Excel template:', byteArray.error);
      }
    } catch (error) {
      console.error('Error downloading Excel template:', error);
    }
  };

  const onNavigate = (date, view) => {
    let start, end;
    if (view === 'month') {
      start = new Date(
        date.getFullYear(),
        date.getMonth(),
        1,
      ).toLocaleDateString('en-CA');
      end = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        0,
      ).toLocaleDateString('en-CA');
    }

    setStartDate(start);
    setEndDate(start === dt ? moment(new Date()).format('YYYY-MM-DD') : end);
  };

  const activeMonth = new Date(startDate + 'T00:00:00').getMonth();
  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          marginTop: people.id
            ? screenWidth > 900
              ? '-42px'
              : '-10px'
            : '-30px',
        }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={checked}
              onChange={handleChange}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          }
          label="Year view summary"
        />
        <Button
          variant="outlined"
          style={{
            cursor: 'pointer',
            marginTop: '0.5rem',
            marginBottom: '0.5rem',
            whiteSpace: 'nowrap',
            marginLeft: '1rem',
          }}
          startIcon={<DownloadIcon />}
          onClick={handledownloadloadExcel}
        >
          Tasks
        </Button>
      </div>
      {loader ? (
        <div style={{ height: '80vh', overflow: 'hidden' }}>
          <GenericLoader
            rectAttributes={TimesheetsComponentLoaderAttribute}
            width={'100%'}
            height={600}
            showError={showError}
            setShowError={setShowError}
          />
        </div>
      ) : (
        <Box>
          {checked ? (
            <Box marginTop={'20px'}>
              <CalendarView />
            </Box>
          ) : (
            <Box className="main-content-overlay">
              <Box className="main-content-div">
                {loader ? (
                  <Box>
                    <MyLoader style={{ width: '100%' }} />
                  </Box>
                ) : (
                  <Box>
                    <TimeCalendar
                      defaultDate={moment().toDate()}
                      defaultView="month"
                      localizer={localizer}
                      views={['month']}
                      onSelectSlot={selectSpecificDate}
                      selectable
                      startAccessor="start"
                      endAccessor="end"
                      style={{ color: MAIN_BLUE }}
                      components={{
                        toolbar: CustomToolbar({}),
                        event: (eventProps) => (
                          <CustomEvent
                            {...eventProps}
                            activeMonth={activeMonth}
                            colorLabels={labels}
                            parsedEventsData={parsedEventsData}
                          />
                        ),
                      }}
                      onNavigate={onNavigate}
                      onSelectEvent={selectSpecificDate}
                      events={parsedEventsData}
                      dayPropGetter={dayPropGetter}
                    />

                    {drawerState.right && (
                      <SideDrawer
                        closeDrawer={toggleDrawer}
                        drawerOpenFlag={drawerState.right}
                        selectedDate={slotSelectDate}
                        monthlyTimings={monthlyTimings}
                        consolidatedPieData={consolidatedPieData}
                      />
                    )}
                  </Box>
                )}
                {startDate <= dt && (
                  <Box sx={{ marginTop: '1rem' }}>
                    <Accordion expanded={expanded} disableGutters elevation={1}>
                      {/* <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        hidden={true}
                      ></AccordionSummary> */}
                      <AccordionDetails>
                        {summaryloader ? (
                          <Box>
                            <TableLoader style={{ width: '100%' }} />
                          </Box>
                        ) : !noSummary ? (
                          <Box id="scroll">
                            <ViewSummary
                              totalHours={totalHours}
                              officeHours={officeHours}
                              externalHours={externalHours}
                              remoteOfficeHours={remoteOfficeHours}
                              clientOfficeHours={clientOfficeHours}
                              workTravelHours={workTravelHours}
                              weekendWorkingHours={weekendWorkingHours}
                              wfhHours={wfhHours}
                              expectedHours={expectedHours}
                            />
                          </Box>
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '50vh',
                            }}
                          >
                            <div>
                              <Typography>{NO_SUMMARY}</Typography>
                            </div>
                          </div>
                        )}
                      </AccordionDetails>
                    </Accordion>
                  </Box>
                )}
                {/* {startDate <= dt && (
                  <Button
                    id="scroll-btn"
                    onClick={flipSummaryContainer()}
                    sx={{
                      ':hover': { opacity: '0.8' },
                    }}
                  >
                    <Box component="span">
                      {!expanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                    </Box>
                    Summary
                  </Button>
                )} */}
              </Box>
            </Box>
          )}
        </Box>
      )}
    </div>
  );
};

export default TimesheetsComponent;
